import { render, staticRenderFns } from "./login-password.vue?vue&type=template&id=71f6eadd&scoped=true"
import script from "./login-password.vue?vue&type=script&lang=js"
export * from "./login-password.vue?vue&type=script&lang=js"
import style0 from "./login-password.vue?vue&type=style&index=0&id=71f6eadd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f6eadd",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/account/model/login-password.vue
// module id = null
// module chunks = 